export default ['Confidence', 'Patience', 'IOU', 'Reset', 'Draw Object'];
